// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import WebAppointmentListListResultModel from '../../model/web-appointment-list-list-result-model';
import WebAppointmentListListResultDTO from '../dto/web-appointment-list-list-result-dto';
import dtoSchema from '../schemas/web-appointment-list-list-result-schema';
import WebAppointmentListModel from '../../model/web-appointment-list-model';
import ResourceLinkModel from '../../model/resource-link-model';

export default abstract class WebAppointmentListListResultModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<WebAppointmentListListResultDTO>) {
    super();
    if (data) {
      this.items = data.items?.map((i) => WebAppointmentListModel.toModel(i)) ?? [];
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
    }
  }
  /**
  */
  items?: WebAppointmentListModel[];
  /**
  */
  links?: ResourceLinkModel[];

  static toModel(dto: DeepPartial<WebAppointmentListListResultDTO>): WebAppointmentListListResultModel;
  static toModel(dto: DeepPartial<WebAppointmentListListResultDTO> | undefined | null): WebAppointmentListListResultModel | undefined;
  static toModel(dto: DeepPartial<WebAppointmentListListResultDTO> | undefined | null): WebAppointmentListListResultModel | undefined {
    return dto ? new WebAppointmentListListResultModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<WebAppointmentListListResultModel> | WebAppointmentListListResultModel): WebAppointmentListListResultDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      items: unwrapped.items,
      links: unwrapped.links,
    } as WebAppointmentListListResultDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for WebAppointmentListListResultModel, can not map to WebAppointmentListListResultDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
